export function mapNumber(
  value: number,
  min: number,
  max: number,
  newMin: number,
  newMax: number,
  clamp = false,
): number {
  const result = ((value - min) / (max - min)) * (newMax - newMin) + newMin;
  if (clamp) {
    return Math.max(newMin, Math.min(newMax, result));
  }
  return result;
}
